/**
 * Achievement Definitions
 * All available achievements in the system
 */

export const ACHIEVEMENT_RARITY = {
  COMMON: 'COMMON',
  RARE: 'RARE',
  EPIC: 'EPIC',
  LEGENDARY: 'LEGENDARY'
};

export const ACHIEVEMENTS = {
  // Milestone Achievements
  SHIFTS_100: {
    achievementId: 'SHIFTS_100',
    name: '100 Shifts',
    nameThai: '100 เวร',
    icon: '🎖️',
    description: 'ทำเวรครบ 100 เวร',
    requirement: {
      type: 'shifts_completed',
      value: 100
    },
    reward: {
      points: 1000,
      coins: 500,
      xp: 2000,
      badge: null
    },
    rarity: ACHIEVEMENT_RARITY.EPIC
  },
  SHIFTS_500: {
    achievementId: 'SHIFTS_500',
    name: '500 Shifts',
    nameThai: '500 เวร',
    icon: '🏅',
    description: 'ทำเวรครบ 500 เวร',
    requirement: {
      type: 'shifts_completed',
      value: 500
    },
    reward: {
      points: 5000,
      coins: 2500,
      xp: 10000,
      badge: null
    },
    rarity: ACHIEVEMENT_RARITY.LEGENDARY
  },
  SHIFTS_1000: {
    achievementId: 'SHIFTS_1000',
    name: '1000 Shifts',
    nameThai: '1000 เวร',
    icon: '🥇',
    description: 'ทำเวรครบ 1000 เวร',
    requirement: {
      type: 'shifts_completed',
      value: 1000
    },
    reward: {
      points: 10000,
      coins: 5000,
      xp: 20000,
      badge: null
    },
    rarity: ACHIEVEMENT_RARITY.LEGENDARY
  },
  INSPECTIONS_100: {
    achievementId: 'INSPECTIONS_100',
    name: '100 Inspections',
    nameThai: '100 การตรวจสอบ',
    icon: '📋',
    description: 'ตรวจสอบอุปกรณ์ครบ 100 ครั้ง',
    requirement: {
      type: 'inspections_completed',
      value: 100
    },
    reward: {
      points: 500,
      coins: 250,
      xp: 1000,
      badge: null
    },
    rarity: ACHIEVEMENT_RARITY.EPIC
  },
  STREAK_365: {
    achievementId: 'STREAK_365',
    name: '365 Days Streak',
    nameThai: '365 วันติดต่อกัน',
    icon: '🔥',
    description: 'เข้าสู่ระบบติดต่อกัน 365 วัน',
    requirement: {
      type: 'login_streak',
      value: 365
    },
    reward: {
      points: 5000,
      coins: 2000,
      xp: 10000,
      badge: null
    },
    rarity: ACHIEVEMENT_RARITY.LEGENDARY
  },

  // Special Achievements
  EARLY_BIRD: {
    achievementId: 'EARLY_BIRD',
    name: 'Early Bird',
    nameThai: 'นกเช้า',
    icon: '🌅',
    description: 'เข้าเวรก่อน 6 โมงเช้า 10 ครั้ง',
    requirement: {
      type: 'early_shifts',
      value: 10
    },
    reward: {
      points: 200,
      coins: 100,
      xp: 400,
      badge: null
    },
    rarity: ACHIEVEMENT_RARITY.RARE
  },
  NIGHT_SHIFT_HERO: {
    achievementId: 'NIGHT_SHIFT_HERO',
    name: 'Night Shift Hero',
    nameThai: 'ฮีโร่เวรดึก',
    icon: '🌙',
    description: 'ทำเวรดึกครบ 50 เวร',
    requirement: {
      type: 'night_shifts_completed',
      value: 50
    },
    reward: {
      points: 500,
      coins: 250,
      xp: 1000,
      badge: null
    },
    rarity: ACHIEVEMENT_RARITY.EPIC
  },
  PROBLEM_SOLVER: {
    achievementId: 'PROBLEM_SOLVER',
    name: 'Problem Solver',
    nameThai: 'ผู้แก้ปัญหา',
    icon: '🛠️',
    description: 'รายงานและแก้ไขปัญหา 20 ครั้ง',
    requirement: {
      type: 'issues_resolved',
      value: 20
    },
    reward: {
      points: 400,
      coins: 200,
      xp: 800,
      badge: null
    },
    rarity: ACHIEVEMENT_RARITY.EPIC
  },
  TEAM_PLAYER_ACHIEVEMENT: {
    achievementId: 'TEAM_PLAYER_ACHIEVEMENT',
    name: 'Team Player',
    nameThai: 'ผู้เล่นทีม',
    icon: '🤝',
    description: 'เข้าร่วมกิจกรรมทีม 10 ครั้ง',
    requirement: {
      type: 'team_activities',
      value: 10
    },
    reward: {
      points: 300,
      coins: 150,
      xp: 600,
      badge: null
    },
    rarity: ACHIEVEMENT_RARITY.RARE
  }
};

// Get all achievements as array
export const getAllAchievements = () => Object.values(ACHIEVEMENTS);

// Get achievement by ID
export const getAchievementById = (achievementId) => {
  return ACHIEVEMENTS[achievementId] || null;
};

